<!-- <div *ngIf="source == 'userForm' || global.selectedEduCategoryTitle">
    <p class="page-title">{{title}}</p>
</div> -->
<div *ngIf="source == 'userForm'">
    <p class="page-title">{{title}}</p>
</div>

<div class="content-container" [ngClass]="{ 'content-edu-conatiner' : (this.source != 'userForm' && this.source != 'lessonCategories')}">
    <div *ngIf = "this.source == 'userForm'">
        <app-user-form></app-user-form>
    </div>
    <div *ngIf = "this.source == 'lessonCategories'">
        <app-button-selection (buttonSelectEvent)="returnedButtonSelection($event)"></app-button-selection>
    </div>
    <div class="edu-container" *ngIf = "this.source != 'userForm' && this.source != 'lessonCategories'">
        <!-- TODO: was working with this before, need to remove -->
        <!-- <app-medicare-definition></app-medicare-definition> -->

        <!-- TODO: need to build wizard with tabs here ? -->
        <app-educational-content></app-educational-content>
    </div>
    <!-- <div *ngIf = "this.source == 'lessonCategories'">
        <app-button-selection></app-button-selection>
    </div> -->
    <!-- <div *ngIf = "this.source == 'medicare'">
        <app-medicare-definition></app-medicare-definition>
    </div> -->

</div>
<div class="button-container" *ngIf="this.source == 'userForm'">
    <button class="button empty-button" (click)="back()">Back</button>
    <button [ngClass]="{ 'disabled-button' : this.formService.userObjectForm.valid === false }" class="button filled-green-button" (click)="next()">Continue</button>
  </div>


